<vdr-ck-editor [readonly]="readonly" [formControl]="formControl" ></vdr-ck-editor>